import React from 'react';
import PropTypes from 'prop-types';

const TriggerModal = ({ toggleSearchModal }) => (
  <span
    role="button"
    className="material-icons searchModal-search-icon"
    onClick={toggleSearchModal}>
    search
  </span>
);

TriggerModal.propTypes = {
  toggleSearchModal: PropTypes.func.isRequired
};

export default TriggerModal;
